var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.email)?_c('div',{class:{
        'sw-email': true,
        'sw-email_inverted': _vm.inverted
    }},[_c('a',{attrs:{"href":'mailto:' + _vm.email}},[_vm._v("\n        "+_vm._s(_vm.email)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }